import { getCompanyName, useApiQuery } from 'theSource/utils';
import { CompanyManifestResponseDto } from './types';
import { GET_COMPANY_MANIFEST_QUERY_KEY } from './utils';

interface UseCompanyManifestQueryProps {
  enabled: boolean;
}

export const useCompanyManifestQuery = ({
  enabled,
}: UseCompanyManifestQueryProps) => {
  const companyName = getCompanyName();

  return useApiQuery<CompanyManifestResponseDto, unknown>({
    queryKey: GET_COMPANY_MANIFEST_QUERY_KEY,
    endpoint: `/pwa/${companyName}/manifest.json`,
    showErrorSnackbar: false,
    onSuccess: (data) => {
      const title = document.querySelector('title')!;
      title.textContent = data.name;

      const faviconLink = document.querySelector('[rel="icon"]')!;
      faviconLink.setAttribute('href', data.icons[0].src);

      const appleFaviconLink = document.querySelector(
        '[rel="apple-touch-icon"]'
      )!;
      appleFaviconLink.setAttribute('href', data.icons[0].src);
    },
    enabled: Boolean(enabled && companyName),
  });
};
